import { render } from 'react-dom'
import { Sellers } from '../../Sellers/Sellers'

document.addEventListener('DOMContentLoaded', () => {
  render(<Sellers />, document.getElementById('sellers'))
})
